import moment from 'moment';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { Campaign } from '../../formElements/CampaignSelect/CampaignSelect.queries';
import { List, getListSelectFetchItemsVariables, FetchListParams } from '../../formElements';
import { MessageType } from './types';

export const getDaysAgo = (date: string) => {
  // strip out times to properly calculate day difference
  const currentDate = moment().startOf('day');
  const pastDate = moment(date).startOf('day');

  return currentDate.diff(pastDate, 'days');
};

export const getEventResourceListVariables = (params?: FetchListParams) => ({
  ...getListSelectFetchItemsVariables(params),
  sort: {
    sortBy: 'UpdatedAt',
    sortDirection: SORT_DIRECTIONS.DESCENDING,
  },
});

export const parseCampaignOption = ({ id, name, updatedAt }: Campaign & { updatedAt: string }) => ({
  id: `${name}-${id}`,
  label: name,
  doubleLine: `Campaign ID: ${id} | Updated ${getDaysAgo(updatedAt)} days ago`,
  value: `${id}`,
});

export const parseListOption = ({
  listType,
  id,
  name,
  updatedAt,
}: List & {
  listType: string;
  updatedAt: string;
}) => ({
  id: `${name}-${id}`,
  label: name,
  doubleLine: `List ID: ${id} | ${listType} | Updated ${getDaysAgo(updatedAt)} days ago`,
  value: `${id}`,
});

export const parseMessageTypeOption = ({ id, name, updatedAt, messageChannel }: MessageType) => ({
  id: `${name}-${id}`,
  label: name,
  doubleLine: `Message Type ID: ${id} | ${messageChannel.name} | Updated ${getDaysAgo(
    updatedAt,
  )} days ago`,
  value: `${id}`,
});
